import React from 'react';
import { Badge } from 'reactstrap';

function SummaryBadge({
  n,
  label,
  color,
}) {
  return (
    <div className="me-5">
      <span className="h6">
        {label}
      </span>
      <Badge pill color={color} className="ms-1">
        {typeof n === 'number' && !Number.isNaN(n) ? n : '-'}
      </Badge>
    </div>
  );
}

export default SummaryBadge;
